import { DomainsForTable } from 'features/inventory/domain/components/DomainsTable/types/model'
import { DomainProductsAttributes } from 'features/inventory/domain/forms/DomainTableForm/schema'

export const domainToProductsAttributes = (domain: DomainsForTable): DomainProductsAttributes => ({
  prebidStackEnabled: domain.prebidStackEnabled,
  priceGeniusEnabled: domain.priceGeniusEnabled,
  refresherEnabled: domain.refresherEnabled,
  unfilledRecoveryEnabled: domain.unfilledRecoveryEnabled,
  viewabilityToolsEnabled: domain.viewabilityToolsEnabled,
})
